import {
  Box,
  Button,
  Grid,
  Link,
  Paper,
  Typography,
  styled,
  useTheme
} from '@mui/material';
import { PureLightTheme } from 'src/theme/schemes/PureLightTheme';
import { GridContainer, GridItem } from './Index';
import GBStudentAuth from 'src/assets/images/student-login-bg.jpg';
import GBLogo from 'src/assets/images/gb-logo.svg';

const StudentLoginGridContainerWeb = (props) => {
  return <GridContainer {...props} height="100%" justifyContent="center" />;
};

const StudentLoginAuthBGImage = (props) => {
  return (
    <Box
      {...props}
      sx={{
        position: 'relative',
        width: '100%',
        maxWidth: '100%',
        height: '100%'
      }}
    >
      <img
        src={GBStudentAuth}
        style={{ height: '100%', width: '100%', objectFit: 'cover' }}
      />
      <div
        style={{
          position: 'absolute',
          top: '42px',
          left: '38px',
          padding: '1rem'
        }}
      >
        <img src={GBLogo} />
      </div>
    </Box>
  );
};

const StudentLoginFormMainGridItem = (props) => {
  return <GridItem {...props} backgroundColor="#fff" xs={6} />;
};

const LoginInputGridContainerWeb = styled(Grid)(({ theme }) => ({
  justifyContent: 'center',
  [theme.breakpoints.up('sm')]: {
    padding: '50px 15px 100px 15px'
  },
  [theme.breakpoints.up('md')]: {
    padding: '200px 0 100px 0'
  },
  [theme.breakpoints.up('lg')]: {
    padding: '200px 180px 100px 180px'
  },
  [theme.breakpoints.up('xl')]: {
    padding: '200px 200px 100px 200px'
  }
}));

const StudentLoginFormSubGridItem = (props) => {
  return <GridItem {...props} md={12} mb="65px" />;
};

const StudentLoginGridContainerMobile = (props) => {
  return <GridContainer {...props} backgroundColor="#fff" />;
};

const StudentLoginLogoImageGridItemMobile = (props) => {
  return (
    <GridItem
      {...props}
      component={Paper}
      borderRadius="0"
      p="20px 0 20px 22px"
      mb="36px"
    >
      {' '}
      <img src={GBLogo} width="100px" />
    </GridItem>
  );
};

const TitleGridItemMobile = (props) => {
  return <GridItem {...props} m="0 0 20px 26px" />;
};

const AuthBGImageMobile = (props) => {
  return (
    <Box
      {...props}
      sx={{
        position: 'relative',
        width: '100%',
        maxWidth: '100%',
        height: '100%'
      }}
    >
      <img
        src={GBStudentAuth}
        style={{ height: '100%', width: '100%', objectFit: 'cover' }}
      />
    </Box>
  );
};

const FormBoxMobile = (props) => {
  return (
    <Box
      {...props}
      sx={{
        position: 'absolute',
        top: '70%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        padding: '22px'
      }}
    />
  );
};

export const AuthBGImage = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  maxWidth: '100%',
  height: '100%'
}));

export const StudentLoginTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 900,
  fontFamily: 'Biryani',
  [theme.breakpoints.up('xs')]: {
    fontSize: '25px'
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '30px'
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '40px'
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '50px'
  }
}));

export const LinkComponent = styled(
  (props: {
    href: any;
    variant?: any;
    underline?: any;
    color?: any;
    sx?: any;
    fontWeight?: any;
    fontSize?: any;
  }) => (
    <Link
      variant="body2"
      underline="always"
      color="#343434"
      fontFamily="Poppins"
      fontWeight={600}
      sx={{
        [PureLightTheme.breakpoints.up('md')]: {
          fontSize: '15px'
        },
        [PureLightTheme.breakpoints.up('lg')]: {
          fontSize: '16px'
        }
      }}
      {...props}
    />
  )
)({});

const MyAccount = (props) => {
  const theme = useTheme();
  return (
    <Button
      {...props}
      sx={{
        fontFamily: 'Poppins',
        fontSize: '14px',
        borderRadius: '4px',
        backgroundColor: theme.colors.alpha.orange[100],
        color: theme.colors.alpha.trueWhite[100],
        height: '30px',
        fontWeight: 600
      }}
    />
  );
};

export {
  StudentLoginGridContainerWeb,
  StudentLoginAuthBGImage,
  StudentLoginFormMainGridItem,
  LoginInputGridContainerWeb,
  StudentLoginFormSubGridItem,
  StudentLoginGridContainerMobile,
  StudentLoginLogoImageGridItemMobile,
  TitleGridItemMobile,
  AuthBGImageMobile,
  FormBoxMobile,
  MyAccount
};
